import { useEffect, useMemo, useState } from 'react';
import { FieldsType, SalesforceField } from 'model/SalesforceField';
import { useFormContext } from 'components/Generic/Forms/SalesforceIntegratedForms/FormContext';

type Props = {
  fields: FieldsType;
  stepName: string;
  parentComponentName?: string | undefined;
};

const useSalesforceSharedLogic = ({ fields, stepName, parentComponentName }: Props) => {
  const { formData, updateFormData, updateSummary, hiddenFields } = useFormContext();
  const initialValue = fields.salesforceFieldId?.value
    ? formData.records[0][fields.salesforceFieldId?.value]
    : undefined;
  const [selectedValue, setSelectedValue] = useState<string | null>(initialValue);

  const haveNestedFields = useMemo(() => {
    return (
      fields.items &&
      fields.items.filter((item) => {
        return item.fields.items && item.fields.items?.length !== 0;
      })
    );
  }, [fields.items]);

  const getEnteredFieldsList = useMemo(() => {
    const list = [];
    for (const [key] of Object.entries(formData.records[0])) {
      list.push(key);
    }
    return list;
  }, [formData]);

  const showSection = (field: SalesforceField): boolean => {
    if (field.fields.salesforceFieldId) {
      return true;
    }
    return field.fields.salesforceValue && field.fields.salesforceValue.value === selectedValue;
  };

  const extractSalesforceFieldIds = (data: FieldsType, result: string[] = []) => {
    if (typeof data === 'object' && data !== null) {
      for (const key in data) {
        if (key === 'salesforceFieldId' && data[key].value) {
          result.push(data[key].value);
        }
        extractSalesforceFieldIds((data as any)[key], result);
      }
    }
    return result;
  };

  const valueSelected = (value: string) => {
    setSelectedValue(value);
  };

  useEffect(() => {
    getEnteredFieldsList.forEach((field) => {
      const inputFieldElement = document.querySelector(`[data-id="${field}"]`);
      if (
        !inputFieldElement &&
        extractSalesforceFieldIds(fields).includes(field) &&
        !hiddenFields.includes(field)
      ) {
        updateFormData({
          fieldName: field,
          value: '',
        });
        updateSummary({
          stepName: stepName,
          // @ts-expect-error TODO: type
          fieldName: { storeName: field },
        });
      }
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedValue, fields, stepName]);

  const addBorder = parentComponentName !== 'FieldTypeDefiner';

  return {
    haveNestedFields,
    formData,
    getEnteredFieldsList,
    showSection,
    extractSalesforceFieldIds,
    valueSelected,
    addBorder,
  };
};

export default useSalesforceSharedLogic;
